import Http from 'services/Http';

class ChatFlowIntegration {
  async find(id) {
    const { data } = await Http.get(`/v1/chat-flow-integration/${id}`);
    return data.chatFlowIntegration;
  }

  async list() {
    const { data } = await Http.get(`/v1/chat-flow-integration`);
    return data;
  }

  async create(form) {
    const response = await Http.post(`/v1/chat-flow-integration`, form);
    return response.data.chatFlowIntegration;
  }

  async update(id, form) {
    const response = await Http.patch(`/v1/chat-flow-integration/${id}`, form);
    return response.data.chatFlowIntegration;
  }

  async destroy(id) {
    const { data } = await Http.delete(`/v1/chat-flow-integration/${id}`);
    return data;
  }

  async testConnection(id) {
    const { data } = await Http.post(`/v1/chat-flow-integration/${id}/test`);
    return data;
  }
}

export default new ChatFlowIntegration();
